// Browser-only helper that captures ?ref=CODE from the URL and stashes it in
// sessionStorage so the signup flow can pick it up after the OAuth/email
// round-trip.
import { isValidReferralCode } from "./referrals-shared";

const KEY = "knowmeno_pending_ref";

export function captureRefParam(): void {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && isValidReferralCode(ref.toUpperCase())) {
      window.sessionStorage.setItem(KEY, ref.toUpperCase());
    }
  } catch {
    // ignore
  }
}

export function getPendingRef(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingRef(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
